import { createContext, useContext } from "react";

import type { PackageDetailContextValue } from "./types";

export const PackageDetailContext = createContext<PackageDetailContextValue | null>(null);

export function usePackageDetailContext() {
  const context = useContext(PackageDetailContext);
  if (!context) {
    throw new Error("PackageDetail parts must be rendered inside <PackageDetail>");
  }
  return context;
}
